import React from 'react';
import { View, StyleSheet, Text, ScrollView } from 'react-native';
import { useTranslation } from 'react-i18next';
import { BottomSheet } from '../../weekly/v2/primitives/BottomSheet';
import { AddFoodContent } from '../AddFoodContent';
import { ZONE_META } from '../zoneMeta';
import { PaprikaZones } from '../../../styles/theme';
import { PantryLocation } from '../../../utils/pantryLocation';

interface Props {
  visible: boolean;
  onClose: () => void;
  zone: PantryLocation;
  onAdd: (food: { name: string; category: string }) => void;
  onPhoto: (zone: PantryLocation) => void;
}

export function QuickAddSheet({ visible, onClose, zone, onAdd, onPhoto }: Props) {
  const { t } = useTranslation();
  const zoneMeta = ZONE_META[zone];
  const zoneColors = PaprikaZones[zone];

  const handleAdd = (food: { name: string; category: string }) => {
    onAdd(food);
    onClose();
  };

  const handlePhoto = () => {
    onPhoto(zone);
    onClose();
  };

  return (
    <BottomSheet visible={visible} onClose={onClose}>
      <ScrollView
        style={styles.scrollView}
        contentContainerStyle={styles.container}
        scrollEnabled={false}
      >
        {/* Title */}
        <Text style={[styles.title, { color: zoneColors.accent }]}>
          {t('pantry.add.toZone', { zone: t(zoneMeta.labelKey).toLowerCase() })}
        </Text>

        <AddFoodContent
          zone={zone}
          onAdd={handleAdd}
          onPhoto={handlePhoto}
          showPhotoButton={true}
          showSearchField={true}
          showRecentsLabel={true}
        />
      </ScrollView>
    </BottomSheet>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
  container: {
    paddingHorizontal: 16,
  },
  title: {
    fontFamily: 'Inter-SemiBold',
    fontSize: 11,
    fontWeight: '700',
    letterSpacing: 0.05,
    textTransform: 'uppercase',
    marginBottom: 12,
  },
});
